import Stimp from 'stimp/lib/index';
import { TheList } from "./components/TheList";
import { TheListForm } from "./components/TheListForm";
import { Header } from "./components/Header";
import { BirdsSigning } from "./components/BirdsSigning";
import { BTT } from "./components/BTT";

const app = new Stimp.App('main', {
  isDebug: true,
});
app.addModule(TheList, 'theList');
app.addModule(TheListForm, 'theListForm');
app.addModule(Header, 'header');
app.addModule(BirdsSigning, 'birdsSigning');
app.addModule(BTT, 'btt');

export {
  app
}